// Weather code mappings for Open-Meteo API
export const WEATHER_CODES = {
  0: 'Clear sky',
  1: 'Mainly clear',
  2: 'Partly cloudy',
  3: 'Overcast',
  45: 'Foggy',
  48: 'Depositing rime fog',
  51: 'Light drizzle',
  53: 'Moderate drizzle',
  55: 'Dense drizzle',
  61: 'Slight rain',
  63: 'Moderate rain',
  65: 'Heavy rain',
  71: 'Slight snow',
  73: 'Moderate snow',
  75: 'Heavy snow',
  77: 'Snow grains',
  80: 'Slight rain showers',
  81: 'Moderate rain showers',
  82: 'Violent rain showers',
  85: 'Slight snow showers',
  86: 'Heavy snow showers',
  95: 'Thunderstorm',
  96: 'Thunderstorm with slight hail',
  99: 'Thunderstorm with heavy hail'
};

// Weather icon mappings - more specific emojis for each condition
export const getWeatherIcon = (code) => {
  // Clear conditions
  if (code === 0) return '☀️';      // Clear sky
  if (code === 1) return '🌤️';      // Mainly clear
  if (code === 2) return '⛅';      // Partly cloudy
  if (code === 3) return '☁️';      // Overcast
  
  // Fog conditions
  if (code === 45) return '🌫️';     // Fog
  if (code === 48) return '🌁';     // Rime fog
  
  // Drizzle
  if (code === 51) return '🌦️';     // Light drizzle
  if (code === 53) return '🌧️';     // Moderate drizzle
  if (code === 55) return '🌧️';     // Dense drizzle
  
  // Rain
  if (code === 61) return '🌦️';     // Slight rain
  if (code === 63) return '🌧️';     // Moderate rain
  if (code === 65) return '⛈️';     // Heavy rain
  
  // Snow
  if (code === 71) return '🌨️';     // Slight snow
  if (code === 73) return '❄️';      // Moderate snow
  if (code === 75) return '❄️';      // Heavy snow
  if (code === 77) return '🌨️';     // Snow grains
  
  // Showers
  if (code === 80) return '🌦️';     // Slight rain showers
  if (code === 81) return '🌧️';     // Moderate rain showers
  if (code === 82) return '⛈️';     // Violent rain showers
  if (code === 85) return '🌨️';     // Slight snow showers
  if (code === 86) return '❄️';      // Heavy snow showers
  
  // Thunderstorms
  if (code === 95) return '⛈️';     // Thunderstorm
  if (code === 96) return '⛈️';     // Thunderstorm with slight hail
  if (code === 99) return '⛈️';     // Thunderstorm with heavy hail
  
  return '🌤️'; // Default
};

// Time-aware weather icon mappings for current conditions
export const getTimeAwareWeatherIcon = (code, isNight = false, moonPhaseEmoji = '🌙') => {
  // Night versions for clear/partly cloudy conditions
  if (isNight) {
    if (code === 0) return moonPhaseEmoji;     // Clear - use actual moon phase
    if (code === 1) return '🌙';               // Mainly clear - crescent moon
    if (code === 2) return '☁️';               // Partly cloudy at night
    // For all other conditions, night appearance is the same as day
  }
  
  // Return standard (day) icons
  return getWeatherIcon(code);
};

// Get weather description from code
export const getWeatherDescription = (code) => {
  return WEATHER_CODES[code] || 'Unknown';
};

// Beach flag configurations
export const BEACH_FLAGS = {
  GREEN: {
    color: '🟢',
    text: 'Green - Low hazard',
    details: 'Calm conditions, light surf'
  },
  YELLOW: {
    color: '🟡',
    text: 'Yellow - Medium hazard',
    details: 'Moderate surf and currents'
  },
  RED: {
    color: '🔴',
    text: 'Red - High hazard',
    details: 'Strong surf and currents'
  },
  DOUBLE_RED: {
    color: '🔴🔴',
    text: 'Double Red - Water closed',
    details: 'Dangerous conditions, no swimming'
  },
  PURPLE: {
    color: '🟣',
    text: 'Purple - Marine pests',
    details: 'Dangerous marine life present'
  }
};